// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconRmsTimeSeries_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M22 12C22 17.5228 17.5228 22 12 22C10.517 22 9.10933 21.6772 7.84353 21.0979C7.22253 20.8138 6.63567 20.4679 6.0908 20.0681L8.47797 18.0416L2.19287 16.8186L2.37936 23.2189L4.53068 21.3926L4.59052 21.4399C5.1276 21.8621 5.7016 22.2394 6.30687 22.5662C8.00085 23.4808 9.9398 24 12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C11.0977 0 10.2187 0.0995801 9.37334 0.28835L9.97479 2.20519C10.6288 2.07066 11.3062 2 12 2C17.5228 2 22 6.47715 22 12ZM2.04938 13C2.11946 13.7059 2.26293 14.3901 2.47207 15.045L0.317965 14.7559C0.183854 14.1852 0.0904778 13.5988 0.0410738 13L0.0385077 12.9684C0.0129993 12.649 0 12.326 0 12C0 11.4475 0.0373335 10.9038 0.109615 10.3712L2.07023 10.8087C2.02385 11.1993 2 11.5969 2 12C2 12.3375 2.01672 12.6711 2.04938 13ZM8.06635 2.80339L7.4649 0.88655C6.12989 1.43189 4.91509 2.21079 3.87128 3.17246L5.3501 4.53133C6.15061 3.81808 7.06653 3.23159 8.06635 2.80339ZM3.99651 6.00367L2.51768 4.6448C1.64982 5.76203 0.975051 7.03672 0.543479 8.41879L2.50414 8.85631C2.84704 7.81997 3.35486 6.85873 3.99651 6.00367ZM11 4H13V11H20V13H13H11V11V4Z" class="svg-bg"/>
</svg>
`;
/**
 * IconRmsTimeSeries is a generated icon component.
 */
let IconRmsTimeSeries = IconRmsTimeSeries_1 = class IconRmsTimeSeries extends IconBaseElement {
    render() {
        return html `${IconRmsTimeSeries_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconRmsTimeSeries.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconRmsTimeSeries = IconRmsTimeSeries_1 = __decorate([
    customElement('zui-icon-rms-time-series')
], IconRmsTimeSeries);
export { IconRmsTimeSeries };
